/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BookingStrictHttpResponse } from '../../booking-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAdminTriggerFhirSyncPost$Params {
}

export function apiAdminTriggerFhirSyncPost(http: HttpClient, rootUrl: string, params?: ApiAdminTriggerFhirSyncPost$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAdminTriggerFhirSyncPost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BookingStrictHttpResponse<void>;
    })
  );
}

apiAdminTriggerFhirSyncPost.PATH = '/api/Admin/TriggerFhirSync';
